// import { useEffect, useState } from "react";
// import ImageWithSkeleton from "../components/ImageWithSkeleton";
// import GallerySkeleton from "../components/GallerySkeleton";
// // import axios from "axios";
// import api from "../api/axiosInstance";

// // const BACKEND_URL = "http://localhost:8081";
// // const BACKEND_URL = "https://api.rangpurgolf.com";

// const ImageGallery = () => {
//   const [loading, setLoading] = useState(true);
//   const [galleryImages, setGalleryImages] = useState([]);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // ✅ Fetch images from backend
//   useEffect(() => {
//     const fetchImages = async () => {
//       try {
//         const res = await api.get("/media/get/all", {
//           params: { type: "IMAGE_GALLERY" },
//         });
//         setGalleryImages(res.data.map((item) => item.url)); // assuming MediaFileEntity has `url` field
//       } catch (err) {
//         console.error("Error fetching images:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchImages();
//   }, []);

//   const openLightbox = (index) => {
//     setSelectedImage(galleryImages[index]);
//     setCurrentIndex(index);
//   };

//   const closeLightbox = () => setSelectedImage(null);

//   const navigateImage = (direction) => {
//     let newIndex;
//     if (direction === "prev") {
//       newIndex =
//         (currentIndex - 1 + galleryImages.length) % galleryImages.length;
//     } else {
//       newIndex = (currentIndex + 1) % galleryImages.length;
//     }
//     setCurrentIndex(newIndex);
//     setSelectedImage(galleryImages[newIndex]);
//   };

//   return (
//     <section className="py-16 px-4 md:px-20 bg-white">
//       <h2 className="text-3xl font-bold text-center mb-12 uppercase">
//         RGCC Image Gallery
//       </h2>

//       {loading ? (
//         <GallerySkeleton />
//       ) : (
//         <div
//           className={`grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 transition-opacity duration-700 ${
//             loading ? "opacity-0" : "opacity-100"
//           }`}
//         >
//           {galleryImages.map((image, index) => (
//             <div
//               key={index}
//               className="relative mb-4 cursor-pointer group inline-block"
//               onClick={() => openLightbox(index)}
//             >
//               <ImageWithSkeleton
//                 src={image}
//                 alt={`Gallery ${index + 1}`}
//                 className="w-full h-48 object-cover rounded-md transition-transform duration-500 group-hover:scale-105"
//               />
//               <div className="absolute inset-0 flex items-center justify-center bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300">
//                 <svg
//                   className="w-10 h-10 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
//                   />
//                 </svg>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* ✅ Lightbox unchanged */}
//       {selectedImage && (
//         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
//           <button
//             onClick={closeLightbox}
//             className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &times;
//           </button>

//           <button
//             onClick={() => navigateImage("prev")}
//             className="absolute left-4 md:left-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10094;
//           </button>

//           <div className="max-w-4xl w-full">
//             <img
//               src={selectedImage}
//               alt="Selected"
//               className="w-full max-h-[80vh] object-contain"
//             />
//           </div>

//           <button
//             onClick={() => navigateImage("next")}
//             className="absolute right-4 md:right-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10095;
//           </button>

//           <div className="absolute bottom-4 text-white">
//             {currentIndex + 1} / {galleryImages.length}
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default ImageGallery;

import { useEffect, useRef, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  X,
  ZoomIn,
  Grid3x3,
  Image as ImageIcon,
  Sparkles,
  Download,
  Share2,
  Maximize2,
  Filter,
} from "lucide-react";
import ImageWithSkeleton from "../components/ImageWithSkeleton";
import GallerySkeleton from "../components/GallerySkeleton";
import api from "../api/axiosInstance";

const ImageGallery = () => {
  const [loading, setLoading] = useState(true);
  const [galleryImages, setGalleryImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [filter, setFilter] = useState("all");
  const [viewMode, setViewMode] = useState("grid");

  // Fetch images from backend
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await api.get("/media/get/all", {
          params: { type: "IMAGE_GALLERY" },
        });
        setGalleryImages(
          res.data.map((item) => ({
            url: item.url,
            category: item.category || "general",
            title: item.title || `Image ${res.data.indexOf(item) + 1}`,
            date: item.createdAt || new Date().toISOString(),
          }))
        );
      } catch (err) {
        console.error("Error fetching images:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  const imageRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (imageRef.current) {
        imageRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
  });

  // Extract unique categories
  const categories = [
    "all",
    ...new Set(galleryImages.map((img) => img.category)),
  ];

  // Filter images
  const filteredImages =
    filter === "all"
      ? galleryImages
      : galleryImages.filter((img) => img.category === filter);

  const openLightbox = (index) => {
    setSelectedImage(filteredImages[index]);
    setCurrentIndex(index);
  };

  const closeLightbox = () => setSelectedImage(null);

  const navigateImage = (direction) => {
    let newIndex;
    if (direction === "prev") {
      newIndex =
        (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    } else {
      newIndex = (currentIndex + 1) % filteredImages.length;
    }
    setCurrentIndex(newIndex);
    setSelectedImage(filteredImages[newIndex]);
  };

  const downloadImage = async (url, title) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `${title || "image"}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const shareImage = async () => {
    if (navigator.share && selectedImage) {
      try {
        await navigator.share({
          title: "RGCC Image Gallery",
          text: `Check out this image from Rangpur Golf & Country Club`,
          url: selectedImage.url,
        });
      } catch (error) {
        console.error("Sharing failed:", error);
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-emerald-600/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-lime-600/20 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-50"></div>
              <div className="relative w-20 h-20 rounded-full bg-gradient-to-br from-emerald-300/20 to-lime-300/20 backdrop-blur-sm border-2 border-emerald-300/30 flex items-center justify-center shadow-2xl">
                <ImageIcon className="w-10 h-10 text-white" />
              </div>
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Visual{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Journey</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-400 to-lime-400 -rotate-1"></span> */}
            </span>{" "}
            Through RGCC
          </h1>

          <p className="text-xl text-emerald-100 max-w-3xl mx-auto mb-8">
            Explore captivating moments from our championship course, events,
            and exclusive club life
          </p>

          <div className="flex items-center justify-center gap-6">
            {/* <div className="flex items-center gap-2 text-emerald-200">
              <Sparkles className="w-5 h-5" />
              <span>Premium Collection</span>
            </div> */}
            {/* <div className="w-1 h-1 bg-emerald-300 rounded-full"></div> */}
            <div className="flex items-center gap-2 text-emerald-200">
              <Grid3x3 className="w-5 h-5" />
              <span>{galleryImages.length}+ Images</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        {/* Filters and Controls */}
        <div
          ref={imageRef}
          className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 mb-8 border border-emerald-100"
        >
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            {/* Filter Buttons */}
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setFilter(category)}
                  className={`px-5 py-2.5 rounded-xl font-medium transition-all duration-300 ${
                    filter === category
                      ? "bg-gradient-to-r from-emerald-500 to-lime-500 text-white shadow-lg"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {category.charAt(0).toUpperCase() + category.slice(1)}
                </button>
              ))}
            </div>

            {/* View Toggle */}
            <div className="flex items-center gap-4">
              <div className="flex border-2 border-gray-200 rounded-xl overflow-hidden">
                <button
                  onClick={() => setViewMode("grid")}
                  className={`p-3 ${
                    viewMode === "grid"
                      ? "bg-emerald-50 text-emerald-600"
                      : "bg-white text-gray-600"
                  }`}
                >
                  <Grid3x3 className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setViewMode("masonry")}
                  className={`p-3 ${
                    viewMode === "masonry"
                      ? "bg-emerald-50 text-emerald-600"
                      : "bg-white text-gray-600"
                  }`}
                >
                  <Maximize2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="mt-6 pt-6 border-t border-gray-100">
            <div className="flex items-center gap-6 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <Filter className="w-4 h-4" />
                <span>
                  Filter: <strong className="text-emerald-600">{filter}</strong>
                </span>
              </div>
              <div className="w-px h-4 bg-gray-200"></div>
              <div>
                Showing{" "}
                <strong className="text-emerald-600">
                  {filteredImages.length}
                </strong>{" "}
                of {galleryImages.length} images
              </div>
            </div>
          </div>
        </div>

        {/* Gallery Grid */}
        {loading ? (
          <GallerySkeleton />
        ) : (
          <div
            className={`transition-opacity duration-700 ${
              loading ? "opacity-0" : "opacity-100"
            }`}
          >
            <div
              className={`${
                viewMode === "grid"
                  ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
                  : "columns-1 sm:columns-2 md:columns-3 gap-6"
              }`}
            >
              {filteredImages.map((image, index) => (
                <div
                  key={index}
                  className={`relative group cursor-pointer mb-6 ${
                    viewMode === "masonry" ? "break-inside-avoid" : ""
                  }`}
                  onClick={() => openLightbox(index)}
                >
                  <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 group-hover:scale-[1.02]">
                    <ImageWithSkeleton
                      src={image.url}
                      alt={image.title}
                      className={`w-full ${
                        viewMode === "masonry"
                          ? "h-auto object-cover"
                          : "h-64 object-cover"
                      } transition-transform duration-700 group-hover:scale-110`}
                    />

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                        <h3 className="font-bold text-lg mb-2 line-clamp-1">
                          {image.title}
                        </h3>
                        <p className="text-sm text-emerald-200">
                          {image.category.toUpperCase()}
                        </p>
                      </div>
                    </div>

                    {/* Zoom Icon */}
                    <div className="absolute top-4 right-4 transform translate-x-4 opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-500">
                      <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                        <ZoomIn className="w-5 h-5 text-white" />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {filteredImages.length === 0 && (
              <div className="text-center py-20">
                <ImageIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-gray-700 mb-2">
                  No images found
                </h3>
                <p className="text-gray-500">
                  Try selecting a different category
                </p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 z-10 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
          >
            <X className="w-6 h-6" />
          </button>

          {/* Navigation Buttons */}
          <button
            onClick={() => navigateImage("prev")}
            className="absolute left-4 md:left-10 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>

          <button
            onClick={() => navigateImage("next")}
            className="absolute right-4 md:right-10 w-12 h-12 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/20 transition-colors duration-300"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          {/* Image Container */}
          <div className="relative max-w-5xl w-full">
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
            />

            {/* Image Info & Actions */}
            <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent text-white rounded-b-lg">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                  <h3 className="text-xl font-bold mb-1">
                    {selectedImage.title}
                  </h3>
                  <div className="flex items-center gap-4 text-sm text-gray-300">
                    <span className="px-3 py-1 bg-emerald-500/20 rounded-full">
                      {selectedImage.category.toUpperCase()}
                    </span>
                    <span>
                      Image {currentIndex + 1} of {filteredImages.length}
                    </span>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <button
                    onClick={() =>
                      downloadImage(selectedImage.url, selectedImage.title)
                    }
                    className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-300 flex items-center gap-2"
                  >
                    <Download className="w-4 h-4" />
                    Download
                  </button>
                  {navigator.share && (
                    <button
                      onClick={shareImage}
                      className="px-4 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-300 flex items-center gap-2"
                    >
                      <Share2 className="w-4 h-4" />
                      Share
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Counter */}
          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-white text-sm">
            {currentIndex + 1} / {filteredImages.length}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
